class SortByModel {
    sortBy = null;
    sortDesc = null;
}
export default SortByModel;
